import React from 'react';
import { useTranslation } from 'react-i18next';
import illustration from '../assets/images/Maintenance-cbconnect.svg';

/**
 * Écran affiché quand le serveur applicatif ne répond plus (502, 503, 504).
 *
 * POURQUOI UN ÉCRAN ET NON UN MESSAGE. Ces codes ne disent pas « votre action a
 * échoué » mais « le service est absent ». Les traiter comme les autres erreurs
 * laissait l'utilisateur devant une page à moitié vide, avec un message rouge
 * qu'il attribuait à sa propre saisie, et le poussait à réessayer en boucle.
 *
 * IL NE PROPOSE PAS DE SE DÉCONNECTER. La session n'est pas en cause : effacer
 * le jeton obligerait à se reconnecter une fois le service revenu, pour une
 * panne qui n'a rien à voir avec l'utilisateur.
 */
export default function PageMaintenance({ onReessayer }) {
  const { t } = useTranslation('commun');
  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        top: 'var(--cb-banniere-h, 0px)',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1900,
        background: '#f8f9fb',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: 24,
        textAlign: 'center',
      }}
    >
      <img
        src={illustration}
        alt=""
        style={{ width: '100%', maxWidth: 380, height: 'auto', marginBottom: 8 }}
      />
      <h1 style={{
        margin: 0, fontSize: 26, fontWeight: 700, color: '#1a6b3c',
        fontFamily: 'Segoe UI, Roboto, Helvetica, Arial, sans-serif',
      }}>
        {t('pageMaintenance.titre')}
      </h1>
      <p style={{ margin: 0, maxWidth: 460, fontSize: 14.5, color: '#5b6672', lineHeight: 1.6 }}>
        {t('pageMaintenance.message')}
      </p>
      {onReessayer && (
        <button
          type="button"
          onClick={onReessayer}
          style={{
            marginTop: 14, padding: '9px 22px', borderRadius: 8,
            border: '1px solid #1a6b3c', background: '#1a6b3c', color: '#fff',
            fontSize: 14, fontWeight: 600, cursor: 'pointer',
          }}
        >
          {t('pageMaintenance.reessayer')}
        </button>
      )}
    </div>
  );
}
